import { getRegExpForSubscriptionPattern, MESSAGE_SEPERATOR, METADATA_SEPERATOR, unwrapMessage, wrapMessage } from "flavr-common";
import { HandshakeMessage, SubscribeMessage, WorkerDiedMessage, WorkerStartedMessage, RequestBusSubscriptionsReadyMessage, BusSubscriptionsReadyMessage } from "./BusMessages";
import { busService } from "./BusService";
export class DedicatedWorker {
    constructor(workerId, port) {
        this.workerId = workerId;
        this.port = port;
        this.onmessage = null;
        this.onmessageerror = null;
        this.subscriptions = [];
        this.patternMap = new Map();
        this.onError = (ev) => {
            console.log(`[bus] Error in dedicated worker ${this.workerId}: `, ev);
        };
        this.onMessageError = (ev) => {
            console.log(`[bus] Message error in dedicated worker ${this.workerId}: `, ev);
            if (!this.onmessageerror)
                return;
            this.onmessageerror(ev);
        };
        this.onMessageReceived = (ev) => {
            if (typeof ev.data === "string") {
                if (ev.data.startsWith("system")) {
                    this.handleSystemEventFromWorker(ev.data);
                    return;
                }
            }
            else if (ev.data.type && ev.data.type === WorkerStartedMessage.typestatic) {
                // Ignore WorkerStartedMessage
                return;
            }
            if (this.onmessage) {
                // check if AskMessage
                if (typeof ev.data !== "string" &&
                    ev.data.askId !== undefined &&
                    ev.data.targetWorkerId === undefined // AnswerMessage ev.data.targetWorkerId != undefined
                ) {
                    busService.registerDedicatedWorkerAskCallback(ev.data.askId, this.onAnswerMessage);
                }
                this.onmessage(ev);
            }
        };
        this.onAnswerMessage = (data) => {
            this.postMessageInternal({
                buf: data.buf,
                pattern: data.pattern,
                askId: data.askId,
                timeStamp: data.timeStamp,
                targetWorkerId: this.workerId
            }, [data.buf]);
        };
        port.onerror = this.onError;
        port.onmessageerror = this.onMessageError;
        port.onmessage = this.onMessageReceived;
    }
    close() {
        this.port.onerror = null;
        this.port.onmessageerror = null;
        this.port.onmessage = null;
        this.port.terminate();
    }
    postMessage(data, transfer) {
        let pattern = "";
        if (typeof data === "string") {
            // filter message by subject/type regexp
            const colon = data.indexOf(MESSAGE_SEPERATOR);
            if (colon === -1) {
                throw new Error("Invalid Message, missing MESSAGE_SEPERATOR. have you used busConnection.send() ?");
            }
            if (data.startsWith("system")) {
                // ignor system events from main
                return false;
            }
            pattern = data.substring(0, colon);
        }
        else {
            pattern = data.pattern;
            const targetWorkerId = data.targetWorkerId;
            if (targetWorkerId) {
                if (targetWorkerId === this.workerId) {
                    this.postMessageInternal(data, transfer);
                    return true;
                }
                return false;
            }
        }
        if (!this.hasPattern(pattern))
            return false;
        if (typeof data !== "string" && data.askId !== undefined && data.targetWorkerId === undefined && !busService.hasAskData(data.askId)) {
            busService.registerDedicatedWorkerAskCallback(data.askId, (data) => {
                busService.postBuffer(data.pattern, data.moduleId, data.timeStamp, data.buf, data.askId, data.targetWorkerId, data.clientId);
            });
        }
        this.postMessageInternal(data);
        return false;
    }
    postMessageInternal(data, transfer) {
        if (transfer) {
            this.port.postMessage(data, transfer);
            return;
        }
        this.port.postMessage(data);
    }
    hasPattern(pattern) {
        let result = this.patternMap.get(pattern);
        if (result)
            return true;
        result = false;
        for (const p of this.subscriptions) {
            if (!p.regexp.test(pattern))
                continue;
            result = true;
            break;
        }
        this.patternMap.set(pattern, result);
        return result;
    }
    updateSubscriptions(subscribe) {
        this.patternMap.clear();
        if (!subscribe.unsubscribe) {
            // subscribe
            for (const pattern of subscribe.pattern) {
                const p = this.subscriptions.find((it) => it.pattern === pattern);
                if (p) {
                    p.refcount++;
                    continue;
                }
                this.subscriptions.push({
                    pattern,
                    refcount: 1,
                    regexp: getRegExpForSubscriptionPattern(pattern)
                });
            }
            // add subscription to handler matched!
            // main worker otherwise throw error
            busService.addSubscription("DedicatedWorker", subscribe.pattern, () => {
                // nothing to do
                // Message is sent in MainMessagePort
            });
            // if we already have a connection, inform the bus immediatly
            if (busService.portConnected()) {
                busService.postWrappedMessage(wrapMessage(new SubscribeMessage(subscribe.pattern), busService.getWorkerId(), "connect", Date.now()));
            }
            return;
        }
        // unsubscribe
        // remove matching pattern
        for (const pattern of subscribe.pattern) {
            const p = this.subscriptions.find((it) => it.pattern === pattern);
            if (p) {
                p.refcount--;
            }
        }
        this.subscriptions = this.subscriptions.filter((it) => it.refcount > 0);
    }
    handleSystemEventFromWorker(data) {
        const msg = unwrapMessage(data);
        if (Array.isArray(msg))
            return;
        const colon = data.indexOf(MESSAGE_SEPERATOR);
        if (colon === -1) {
            return;
        }
        const msgInfos = data.substring(0, colon).split(METADATA_SEPERATOR);
        if (msgInfos.length === 0) {
            return;
        }
        if (SubscribeMessage.is(msg)) {
            this.updateSubscriptions(msg);
        }
        else if (RequestBusSubscriptionsReadyMessage.is(msg)) {
            this.port.postMessage(wrapMessage(new BusSubscriptionsReadyMessage(this.workerId), "bus", "bus", Date.now()));
        }
        else if (HandshakeMessage.is(msg)) {
            this.port.postMessage(msg);
        }
        else if (WorkerDiedMessage.is(msg)) {
            this.onWorkerDied();
        }
    }
    onWorkerDied() {
        this.subscriptions = [];
        this.patternMap.clear();
    }
}
